module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/cleaning-desktop@3x-1e31b30430b51a099cfd77b283a3f5ff.jpg";